import React from "react"
import styles from "./FeedCardUsersReacted.module.scss"
import type { FeedLike } from "../../../types/feed.ts"

interface FeedCardUsersReactedProps {
  users: FeedLike[]
  handleProfile: (id: number | string, completeName: string) => void
}

const FeedCardUsersReacted: React.FC<FeedCardUsersReactedProps> = ({
  users,
  handleProfile,
}) => {
  return (
    <div className={styles.popover} role="list">
      {Array.isArray(users) &&
        users.map((user, index) => {
          const completeName =
            user.user.type === "COMPANY"
              ? user.user.razon_social ?? ""
              : `${user.user.name ?? ""} ${user.user.last_name ?? ""}`.trim()
          const imageProfile = user.user.image_profile
          const userId = user.user?.id ?? (user as { id?: number }).id
          return (
            <button
              type="button"
              key={user.user?.id != null ? String(user.user.id) : `like-${index}`}
              className={styles.popover_row}
              role="listitem"
              onClick={() => handleProfile(userId, completeName)}
            >
              {imageProfile ? (
                <img src={imageProfile} alt="" className={styles.popover_avatar} />
              ) : (
                <span className={styles.popover_avatarPlaceholder} aria-hidden />
              )}
              <span className={styles.popover_name}>{completeName || "Usuario"}</span>
            </button>
          )
        })}
    </div>
  )
}

export default FeedCardUsersReacted
